import * as React from 'react';
import { HomeComponentCA } from './HomeComponentCanada';
import { HomeComponentUS } from './HomeComponentUS';

export function HomeComponent() {

    const [country, setCountry] = React.useState<string|null>(null);

    React.useEffect(() => {

        const getCountry = async () => {

            if (window.location.hostname.includes('hartmann-controls.co.uk')) {
                setCountry('US');
                return;
            }

            const opts: RequestInit = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            }

            try {
                const res = await fetch("https://api.country.is/", opts);
                if (res.status === 200) {
                    const result = await res.json();

                    if (result.country === "CA")
                        setCountry("CA")
                    else
                        setCountry("US")
                } else {
                    setCountry('CA')
                }
            } catch (e) {
                setCountry('CA')
            }
        }

        getCountry();
    }, [])

    return (
        <>
            {country === null ? <div>Loading</div> :
                country == "CA" ? <HomeComponentCA /> :
                    <HomeComponentUS />
            }
        </>
    )
}